import { BaseMutationResultType, BaseQueryResultType } from '@shared/api/graphql/types';
import {
  PointPureType,
  AdCampaignTypeEnum,
  StreamPureType,
  StreamPureDislikeMediafileMutationInput,
  StreamPureDislikeMediafileRestoreMutationInput,
  CoverFilePureType,
  PaginationInfoType,
  Maybe,
  StreamPureSetToCompanyPointsMutationInput,
  SmartLkVideoStreamPureSetCompanyTagsInput,
} from '@shared/api/graphql/generated';

/* Common Types */
export enum WeekDaysValues {
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
  Sunday = 7,
}

export { AdCampaignTypeEnum };

export enum PlayingStatusCode {
  NO_CONNECTION = 404,
  PLAYER_DISABLED = 501,
  DOES_NOT_PLAY = 201,
  ON_PAUSE = 402,
  PLAYING = 200,
}

export type StreamType = {
  id: StreamPureType['id'];
  title: StreamPureType['title'];
  description: StreamPureType['description'];
  points: StreamPureType['points'];
};

/* useDislikeMediafiles Types */
export type DislikeMediafileInputType = Pick<StreamPureDislikeMediafileMutationInput, 'id' | 'mediafileId'>;

export type DislikeMediafileResultType = BaseQueryResultType;

export type UseDislikeMediafileType = [
  request: (input: DislikeMediafileInputType) => Promise<boolean | undefined>,
  result: DislikeMediafileResultType,
];

/* useDislikeMediafilesRestore Types */
export type DislikeMediafileRestoreInputType = Pick<
  StreamPureDislikeMediafileRestoreMutationInput,
  'id' | 'mediafileId'
>;

export type DislikeMediafileRestoreResultType = BaseQueryResultType;

export type UseDislikeMediafileRestoreType = [
  request: (input: DislikeMediafileRestoreInputType) => Promise<boolean | undefined>,
  result: DislikeMediafileRestoreResultType,
];

/* useStreamGroups Types */
export type StreamPreviewType = Pick<StreamPureType, 'id' | 'title' | 'description' | 'templateType'> & {
  master?: Maybe<StreamPureType>;
  cover?: Maybe<Pick<CoverFilePureType, 'id' | 'miniatureUri'>>;
};

export type StreamGroupsResultType = BaseQueryResultType & {
  data: {
    streams?: StreamPreviewType[];
    streamsTop?: StreamPreviewType[];
    streamsGenres?: StreamPreviewType[];
  };
  called: boolean;
};

export type UseStreamGroupsType = [
  request: (companyId: string, companyIds: string[], page?: number, pageSize?: number) => void,
  result: StreamGroupsResultType,
];

export type StreamsByBusinessSphereTypeResultType = BaseQueryResultType & {
  data: {
    streams: StreamPreviewType[];
    paginationInfo?: PaginationInfoType;
  };
};

export type UseStreamsByBusinessSphereType = [
  request: (page?: number, currentBusinessSphereId?: string) => Promise<void>,
  result: StreamsByBusinessSphereTypeResultType,
];

/* usePointInitCreate Types */
export type PointType = Pick<
  PointPureType,
  'id' | 'address' | 'typeName' | 'linkName' | 'deviceType' | 'device' | 'playingStatus' | 'stream'
>;

/* useStreamSetToPoints Types */
export type StreamSetToPointsResultType = BaseMutationResultType;

export type UseStreamSetToPointsType = [
  request: (input: StreamPureSetToCompanyPointsMutationInput) => Promise<boolean>,
  result: StreamSetToPointsResultType,
];

export type VideoStreamSetCompanyTagResultType = BaseMutationResultType;

export type UsePointSetCompanyTagsType = [
  request: (input: SmartLkVideoStreamPureSetCompanyTagsInput) => Promise<boolean>,
  result: VideoStreamSetCompanyTagResultType,
];
